import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-person-search-similar-slider',
  templateUrl: './person-search-similar-slider.component.html',
  styleUrls: ['./person-search-similar-slider.component.scss']
})
export class PersonSearchSimilarSliderComponent implements OnInit {
  @Input() candidateDetails;
  @Input() totalcount;
  @Input() linkedinurl;
  @Input() similartabshow;
  uniqueProfiles: any = {};
  linkedin_url: any;
  facebook_url: any;
  twitter_url: any
  github_url: any;
  stackoverflow_url: any;
  behance_url: any;
  dribbble_url: any;
  medium_url: any;
  quora_url: any;

  constructor() { }

  ngOnInit() {
    // this.candidateDetails && this.candidateDetails.profiles && this.candidateDetails.profiles.forEach(profile => {
    //   if (!this.uniqueProfiles[profile.network]) {
    //     this.uniqueProfiles[profile.network] = profile;
    //     if (profile.network === "linkedin") {
    //       if(profile.url){
    //         this.linkedin_url = profile.url;
    //       }
    //     } else if(profile.network === "facebook") {
    //       this.facebook_url = profile.url;
    //     } else if(profile.network === "twitter") {
    //       this.twitter_url = profile.url;
    //     } else if(profile.network === "github") {
    //       this.github_url = profile.url;
    //     } else if(profile.network === "stackoverflow") {
    //       this.stackoverflow_url = profile.url;
    //     } else if(profile.network === "behance") {
    //       this.behance_url = profile.url;
    //     } else if(profile.network === "dribbble") {
    //       this.dribbble_url = profile.url;
    //     } else if(profile.network === "medium") {
    //       this.medium_url = profile.url;
    //     } else if(profile.network === "quora") {
    //       this.quora_url = profile.url;
    //     }
    //   }
     
    // });

  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    else if (type == 'website'){
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }

  isBoolean(value: any){
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

    // not in an indian format
    formatNumberToIndianFormat(number) {
      if (number) {
        const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
        for (const suffix of suffixes) {
          if (Math.abs(number) < 1000) {
            return Math.floor(number) + suffix;
          }
          number /= 1000;
        }
        return Math.floor(number) + 'T';
      } else {
        return 0
      }
    }

    redirecttolisting() {
      const downloadLink = document.createElement("a");
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute("href", environment.frontendurl + "/person/search/listing?linkedinurl=" + this.linkedinurl);
      downloadLink.setAttribute("target", "_blank");
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }

}
